import { render } from "./NavTab.vue?vue&type=template&id=1ac0267f"
import script from "./NavTab.vue?vue&type=script&lang=js"
export * from "./NavTab.vue?vue&type=script&lang=js"

import "./NavTab.vue?vue&type=style&index=0&id=1ac0267f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__